import axios from 'axios';
import { API } from '@config/common';

export const fetchedUserProfile = (userId) => {
  return axios({
    method: 'get',
    url: `${API.PROFILE}${userId}`,
    headers: { authorization: sessionStorage.getItem('accessToken') },
  });
};

export const fetchedUserSummary = () => {
  return axios({
    method: 'get',
    url: `${API.USER_SUMMARY}`,
    headers: { authorization: sessionStorage.getItem('accessToken') },
  });
};

export const fetchedProfileImg = () => {
  return axios({
    method: 'get',
    url: API.PROFILE_IMG,
    headers: { authorization: sessionStorage.getItem('accessToken') },
    responseType: 'arraybuffer',
  });
};

export const fetchedJoinedFCProfileImg = () => {
  return axios({
    method: 'get',
    url: API.LOGO,
    headers: { authorization: sessionStorage.getItem('accessToken') },
    responseType: 'arraybuffer',
  });
};

export const editUserProfile = (telno) => {
  return axios({
    method: 'put',
    url: API.PROFILE,
    headers: {
      authorization: sessionStorage.getItem('accessToken'),
      'content-type': 'application/json',
    },
    data: { telno },
  });
};

export const editUserImage = (photoFile) => {
  const formData = new FormData();
  formData.append('file', photoFile);
  return axios({
    method: 'put',
    url: API.PROFILE_IMG,
    headers: {
      authorization: sessionStorage.getItem('accessToken'),
      'content-type': 'multipart/form-data',
    },
    data: formData,
  });
};

export const editUserPassword = (oldPassword, newPassword) => {
  return axios({
    method: 'put',
    url: API.CHANGE_PW,
    headers: {
      authorization: sessionStorage.getItem('accessToken'),
      'content-type': 'application/json',
    },
    data: { password: oldPassword, new_password: newPassword },
  });
};

export const searchFranchise = (franchiseName) => {
  return axios({
    method: 'get',
    url: API.FRANCHISE_SEARCH,
    headers: { authorization: sessionStorage.getItem('accessToken') },
    params: { name: franchiseName },
  });
};

export const requestJoinFC = (franchiseCode) => {
  return axios({
    method: 'put',
    url: API.PROFILE,
    headers: {
      authorization: sessionStorage.getItem('accessToken'),
      'content-type': 'application/json',
    },
    data: { modify_franchise: 'Y', franchise_code: franchiseCode },
  });
};

export const deleteProfile = () => {
  return axios({
    method: 'delete',
    url: API.PROFILE_IMG,
    headers: { authorization: sessionStorage.getItem('accessToken') },
  });
};
